const CLASS_COMMON_PATHS = [
  '/workspace-learning-content',
  '/workspace-evaluation-plan',
] as const;

/**
 * 통합 클래스 보기에서는 단건 클래스 선택 후에만 열 수 있는 경로.
 * (학사일정·멤버·연간시간표 등 통합 지원 페이지는 제외)
 * 연간진도표는 사이드바에서 열 때 클래스 선택이 필요하지만, 통합 보기 홈으로는 사용한다.
 */
export function pathRequiresSingleClassSelection(pathname: string): boolean {
  if (CLASS_COMMON_PATHS.includes(pathname as (typeof CLASS_COMMON_PATHS)[number])) return true;
  if (pathname === '/class-record-memos' || pathname.startsWith('/class-record-memos/')) return true;
  if (pathname === '/weekly-learning-guide' || pathname.startsWith('/weekly-learning-guide/')) return true;
  if (pathname === '/assignment-note' || pathname.startsWith('/assignment-note/')) return true;
  if (pathname === '/assignment-points-note' || pathname.startsWith('/assignment-points-note/')) return true;
  if (pathname === '/point-item-note' || pathname.startsWith('/point-item-note/')) return true;
  if (pathname === '/program/fixed' || pathname.startsWith('/program/fixed/')) return true;
  if (pathname === '/program/project' || pathname.startsWith('/program/project/')) return true;
  if (pathname.startsWith('/program/track/')) return true;
  if (pathname === '/annual-progress-term1' || pathname === '/annual-progress-term2') return true;
  if (pathname.startsWith('/annual-progress-term')) return true;
  return false;
}

/** 통합 클래스 보기에서 클래스 전용 페이지를 벗어날 때 이동하는 기본 페이지 */
export const INTEGRATED_CLASS_HOME_PATH = '/annual-timetable';

export function stripGradeIdFromSearch(search: string): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  params.delete('gradeId');
  const q = params.toString();
  return q ? `?${q}` : '';
}

/**
 * 통합 클래스 보기 선택 후 이동 위치.
 * - 연간진도표: gradeId만 제거하고 유지(전체 클래스 탭)
 * - 클래스 전용 페이지: 연간시간표(통합)로 이동
 * - 그 외: gradeId만 제거하고 유지
 */
export function resolveNavigationAfterSelectIntegrated(
  pathname: string,
  search: string
): { pathname: string; search: string } {
  if (pathname.startsWith('/annual-progress')) {
    return { pathname, search: stripGradeIdFromSearch(search) };
  }
  if (pathRequiresSingleClassSelection(pathname)) {
    return { pathname: INTEGRATED_CLASS_HOME_PATH, search: '' };
  }
  return { pathname, search: stripGradeIdFromSearch(search) };
}
